import { gql } from "@apollo/client";

export const GET_INITIATIVES = gql`
  query GetInitiatives {
    getInitiatives {
      id
      serviceId
      name
      description
      address
      images
      organizationId
      organizations {
        id
        logoUrl
        name
      }
      service {
        name
        id
      }
    }
  }
`;
